module.exports = __webpack_public_path__ + "img/load.6c8b06f5.gif";